import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useLocation } from 'react-router';
import {
  ABOUT_US_PAGE_ROUTE,
  BUSINESS_LOAN_PAGE_ROUTE,
  HOME_PAGE_ROUTE,
  PERSONAL_LOAN_PAGE_ROUTE,
} from '../../data/routes-constants';
import './common.css';

const LendingPartners = ({ classes, isRevamped }) => {
  const location = useLocation();
  const isBusinessLoanPage =
    location.pathname === BUSINESS_LOAN_PAGE_ROUTE ||
    location.search.indexOf('BL') !== -1;
  const isPersonalLoanPage = location.pathname === PERSONAL_LOAN_PAGE_ROUTE;
  const isHomePage = location.pathname === HOME_PAGE_ROUTE;
  const isAboutPage = location.pathname === ABOUT_US_PAGE_ROUTE;

  return (
    <section
      className={`dc_sec_space our_lending_partnr tw-bg-[#fff] lg:tw-py-[0px] ${classes}`}>
      <div className="container">
        <div className="dc_lending_main">
          <div
            className={`dc_hdgtitle tw-text-[#212121] lg:tw-leading-[26px] lg:tw-top-[46px] tw-pointer-events-none tw-select-none sm:tw-border-0 ${isRevamped && 'sm:tw-pb-[0px]'}`}>
            Our Lending Partners
          </div>
          <div className="owl-slider">
            <OwlCarousel
              className="owl-theme"
              loop
              nav={false}
              dots={false}
              autoplay={true}
              smartSpeed={1000}
              margin={8}
              responsive={{
                0: { items: 2 }, // Set 1 item for small screens (width < 600px)
                767: { items: 3 }, // Set 2 items for medium screens (600px <= width < 960px)
                960: { items: 4 }, // Set 2 items for medium screens (600px <= width < 960px)
                1455: { items: 5 }, // Set 2 items for medium screens (600px <= width < 960px)
                1600: { items: 7 }, // Set 4 items for larger screens (width >= 960px)
              }}>
              {(isHomePage || isAboutPage || isBusinessLoanPage) && ( // Bajaj
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon22.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {/* IIFL */}
              <div className="item">
                <div className="dc_partner_box">
                  <div className="lending_pbox">
                    <img
                      className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                      src={require('../../assets/images/dc_op_icon3.webp')}
                      alt=""
                      loading="lazy"></img>
                  </div>
                </div>
              </div>

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Flexiloans
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon4.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Credit Saison
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon26.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // neo growth
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon8.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {/* Goodrej */}
              <div className="item">
                <div className="dc_partner_box">
                  <div className="lending_pbox">
                    <img
                      className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                      src={require('../../assets/images/dc_op_icon9.webp')}
                      alt=""
                      loading="lazy"></img>
                  </div>
                </div>
              </div>

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Piramal
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon29.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // lendingKart
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon6.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // indifi
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon18.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Protium
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon12.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {/* Tata Capitals */}
              <div className="item">
                <div className="dc_partner_box">
                  <div className="lending_pbox">
                    <img
                      className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                      src={require('../../assets/images/dc_op_icon10.webp')}
                      alt=""
                      loading="lazy"></img>
                  </div>
                </div>
              </div>

              {(isPersonalLoanPage ||
                isHomePage ||
                isAboutPage ||
                isBusinessLoanPage) && ( // lnT
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon11.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Poonawala
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon23.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Ugro
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon19.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Arka
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon27.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isPersonalLoanPage ||
                isHomePage ||
                isAboutPage ||
                isBusinessLoanPage) && ( // InCred
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon2.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // KreditBee
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon24.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {/* ICIC */}
              <div className="item">
                <div className="dc_partner_box">
                  <div className="lending_pbox">
                    <img
                      className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                      src={require('../../assets/images/dc_op_icon14.webp')}
                      alt=""
                      loading="lazy"></img>
                  </div>
                </div>
              </div>

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Ambit
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon5.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {/* Standard Chartered */}
              {(isHomePage || isAboutPage) && (
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon7.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Clix
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon13.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Chola
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon15.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage ||
                isPersonalLoanPage ||
                isHomePage ||
                isAboutPage) && ( // SMFG
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon32.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Aditya
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon17.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isPersonalLoanPage || isHomePage || isAboutPage) && ( // Fibe
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon20.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isPersonalLoanPage || isHomePage || isAboutPage) && ( // pay sense
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon21.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Tru
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon25.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // MAS
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon28.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Axis
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon30.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // HeroMoto Fincorp
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon31.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}

              {(isBusinessLoanPage || isHomePage || isAboutPage) && ( // Yes bank
                <div className="item">
                  <div className="dc_partner_box">
                    <div className="lending_pbox">
                      <img
                        className="tw-max-w-[90px] tw-h-auto tw-max-h-[32px] tw-pointer-events-none tw-select-none"
                        src={require('../../assets/images/dc_op_icon33.webp')}
                        alt=""
                        loading="lazy"></img>
                    </div>
                  </div>
                </div>
              )}
            </OwlCarousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LendingPartners;
